<template>
    <v-btn outlined x-small color="grey" @click="reload">Versão: {{ version }}</v-btn>
</template>

<script>
import packageJson from '@/../package.json';

export default {
    data() {
        return {
            version: packageJson.version,
        };
    },
    methods: {
        reload() {
            document.location.reload(true);
        },
    },
};
</script>